import { ClickRedirect } from '@3pc/click-redirect';

const clickRedirectList = ClickRedirect.InitViaDom();
clickRedirectList.forEach(clickRedirect => clickRedirect.activate());
